import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MediaViewer from "components/common/MediaViewer";
import { Link } from "react-router-dom";


function Logo({ logo, toggleSidebar }) {
    if (!logo) return null;

    return (
        <div className="cornerLogo">
            {logo.isLoading ? 
                <FontAwesomeIcon className="ml-3" icon={faSpinner} spin size="2x" />
            :  
                <div className="simple-text logo-mini" onClick={toggleSidebar}>
                    <div className="logo-img" style={{ height: "100%", width: "auto" }}>
                        { logo.logo_upload_id ?
                            <MediaViewer uploadId={logo.logo_upload_id} maxHeight="3em" />
                        :
                            <img src={logo.imgSrc} alt="react-logo" width={"40em"} />
                        }
                    </div>
                </div>
            }
        </div>
    );
}

export default Logo